module.exports = __webpack_public_path__ + "img/beneat-coin.cc08f852.svg";